export default __webpack_public_path__ + "static/media/misc-books4-2048w.3905f01e.webp";